import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {LiveCasinoFilterButtonIconDefaultBox} from "./live-casino-filter-button-icon.default.box";
import {LiveCasinoFilterIconSIBox} from "./live-casino-filter-button-icon.si.box";
import {LiveCasinoFilterIconMrGreenBox} from "./live-casino-filter-button-icon.mrgreen.box";

export const LiveCasinoFilterButtonIconBox = styledByTheme(LiveCasinoFilterButtonIconDefaultBox)
    .forSI(LiveCasinoFilterIconSIBox)
    .forSICis(LiveCasinoFilterIconSIBox)
    .forMrGreen(LiveCasinoFilterIconMrGreenBox)
    .apply();